

export default defineNuxtRouteMiddleware((to, from) => {
    if (process.env.NODE_ENV === 'development') {
        console.log(` to: ${to.path}, from: ${from.path}`)
    }
})
